import React, { useState } from 'react';
import axios from 'axios';
import './Pages.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PRODUCTS = [
  "Ashwagandha Root Powder",
  "Moringa Leaf Powder",
  "Turmeric Powder",
  "Ginger Powder",
  "Amla Powder",
  "Neem Powder",
  "Other (specify in message)"
];

const PURPOSES = [
  "Evaluation",
  "Compliance",
  "Registration",
  "Other"
];

function RequestCOAPage() {
  const [formData, setFormData] = useState({
    full_name: '',
    company_name: '',
    contact: '',
    country: '',
    product: '',
    purpose: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await axios.post(`${API}/coa-request`, formData);
      setSubmitStatus({ type: 'success', message: response.data.message });
      setFormData({
        full_name: '',
        company_name: '',
        contact: '',
        country: '',
        product: '',
        purpose: '',
        message: ''
      });
    } catch (error) {
      setSubmitStatus({ type: 'error', message: 'Failed to submit. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page-container form-page">
      <div className="page-header">
        <h1>Request COA / Specs</h1>
        <div className="title-underline"></div>
      </div>
      
      <div className="page-intro">
        <p>To support buyer evaluation and compliance, we can share COA and technical details on request.</p>
      </div>

      {submitStatus?.type === 'success' ? (
        <div className="success-message">
          <div className="success-icon">✓</div>
          <h3>Thank you!</h3>
          <p>{submitStatus.message}</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="request-form">
          <div className="form-row">
            <div className="form-group">
              <label>Full Name *</label>
              <input type="text" name="full_name" value={formData.full_name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Company Name</label>
              <input type="text" name="company_name" value={formData.company_name} onChange={handleChange} />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Email / WhatsApp *</label>
              <input type="text" name="contact" value={formData.contact} onChange={handleChange} required placeholder="Email or WhatsApp number" />
            </div>
            <div className="form-group">
              <label>Country *</label>
              <input type="text" name="country" value={formData.country} onChange={handleChange} required />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Product *</label>
              <select name="product" value={formData.product} onChange={handleChange} required>
                <option value="">Select Product</option>
                {PRODUCTS.map(p => <option key={p} value={p}>{p}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Purpose *</label>
              <select name="purpose" value={formData.purpose} onChange={handleChange} required>
                <option value="">Select Purpose</option>
                {PURPOSES.map(p => <option key={p} value={p}>{p}</option>)}
              </select>
            </div>
          </div>

          <div className="form-group full-width">
            <label>Message</label>
            <textarea name="message" value={formData.message} onChange={handleChange} rows="4" placeholder="Any specific requirements or questions..."></textarea>
          </div>

          {submitStatus?.type === 'error' && (
            <div className="error-message">{submitStatus.message}</div>
          )}

          <button type="submit" className="btn-submit" disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Submit Request'}
          </button>
        </form>
      )}
    </div>
  );
}

export default RequestCOAPage;
